<template>
  <v-row justify="center" >
    <v-dialog v-model="dialog" persistent max-width="800px">

      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('admin.agencies.agency')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :label="$t('sadmin.tenant_list.name_label')" required v-model="objet.name" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :label="$t('booking.user_info.address.header')" required v-model="objet.address" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Longitude" type="number" required v-model="objet.longitude" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Latitude" required type="number" v-model="objet.latitude" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :label="$t('client.account.phone_number_label')" required v-model="objet.phoneNumbers" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field :label="$t('booking.confirmation.email')" required v-model="objet.emails" ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
          <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { AgenciesApi } from '../../../shared/services/api/agencies'

  export default {
    name: "Agency",
    data: () => ({
      dialog: false,
      objet: {},
      resolve: null,
      reject: null,
    }),
    methods: {
      open (objet) {
        this.objet = objet;
        this.dialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      save (){
        AgenciesApi.createAgency(this.objet)
          .then(objet => this.objet = objet)
          .catch(error => this.error = error)
          .finally(() => this.close());
        this.resolve(true)
      },
      close(){
        this.dialog = false;
      }

    }
  }

</script>
